import React from 'react';

class NoCohortView extends React.Component {
    render() {
        return <div className="no-cohort-view">
            <div className="no-cohort-view__title">You have no cohorts yet</div>
            <div className="no-cohort-view__sub-title">Start by creating one</div>
            <div className="action-btn no-cohort-view__create-btn"
                onClick={this.props.createCohort}>
                Create new cohort
            </div>
        </div>;
    }
}

export default NoCohortView;